import {SingleEntityLine} from '../entity/single-entity-line';
import {TagInformation} from '../model/tag-information';

export class TagUtils {

  static createTaggingDetails(singleEntityLines: SingleEntityLine[]): TagInformation[] {
    const tagInformation: TagInformation[] = [];
    for (const line of singleEntityLines.sort((first, second) => first.sequence - second.sequence)) {
      const tag: TagInformation = new TagInformation();
      tag.building = line.building;
      tag.floor = line.fl;
      tag.poLine = line.poline;
      tag.riser = line.riser;
      tag.room = line.room;
      tag.sequence = line.sequence;
      tag.tag = line.tag;
      tagInformation.push(tag);
    }
    return tagInformation;
  }

  static copyTagInformation(original: TagInformation): TagInformation {
    const tagInformation = new TagInformation();
    tagInformation.tag = original.tag;
    tagInformation.room = original.room;
    tagInformation.riser = original.riser;
    tagInformation.poLine = original.poLine;
    tagInformation.floor = original.floor;
    tagInformation.building = original.building;
    tagInformation.sequence = original.sequence;
    return tagInformation;
  }

  static allTaggingIsEqual(tags: TagInformation[]): boolean {
    if (!tags || tags.length === 1) {
      return true;
    }
    const common: TagInformation = tags[0];
    for (const tag of tags) {
      if (!TagUtils.propertiesMatch(tag.tag, common.tag)) {
        return false;
      }
      if (!TagUtils.propertiesMatch(tag.room, common.room)) {
        return false;
      }
      if (!TagUtils.propertiesMatch(tag.riser, common.riser)) {
        return false;
      }
      if (!TagUtils.propertiesMatch(tag.poLine, common.poLine)) {
        return false;
      }
      if (!TagUtils.propertiesMatch(tag.floor, common.floor)) {
        return false;
      }
      if (!TagUtils.propertiesMatch(tag.building, common.building)) {
        return false;
      }
    }
    return true;
  }

  private static propertiesMatch(first: string, second: string): boolean {
    if (!first) {
      return !second;
    } else if (!second) {
      return false;
    } else {
      return first === second;
    }
  }

}
